/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Spinner, useToast } from '@chakra-ui/react';
import axios from 'axios';
import classes from './createdAssets.module.css';
import axiosInstance from '../../../services/api';

const url = process.env.REACT_APP_BASE_URL;

const CreateAssets = ({ setTriggerClose, setRefetch, isEdit, idx, idData }) => {
  const toast = useToast();
  const [values, setValues] = useState({
    client: idData?.client || '',
    brand: idData?.brand || '',
    category: idData?.category || '',
    type: idData?.type || '',
    image: idData?.image || null,
    additionalInfo: idData?.additionalInfo || '',
    buildingNo: idData?.addressDetails?.buildingNo || '',
    streetName: idData?.addressDetails?.streetName || '',
    city: idData?.addressDetails?.city || '',
    LGA: idData?.addressDetails?.LGA || '',
    state: idData?.addressDetails?.state || '',
    country: idData?.addressDetails?.country || '',
    locationName: idData?.addressDetails?.locationName || '',
  });
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creatingAsset, setCreatingAsset] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [hasPhoto, setHasPhoto] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  // Fetch clients on mount
  useEffect(() => {
    const getClients = async () => {
      setLoading(true);
      try {
        const { data } = await axiosInstance.get(`/assets/field/retrieve`);
        setClients(data?.data?.organizations);
      } catch (error) {
        toast({
          title: 'Error',
          description: error?.response?.data?.message || 'Failed to fetch clients',
          status: 'error',
        });
      } finally {
        setLoading(false);
      }
    };
    getClients();
  }, []);



  const [allClusters, setAllClusters] = useState([])
  const [loadingClusters, setLoadingClusters] = useState(false)

  useEffect(() => {

    const getClusters = async () => {
      let page = 1;
      const limit = 100;
      let allCs = [];
      let totalCount = 0;
      let hasNextPage = true;

      setLoadingClusters(true);
      try {
        while (hasNextPage) {
          const res = await axiosInstance.get(`assets/cluster/all?page=${page}&limit=${limit}&clientID=${values.client}`);
          const { data } = res.data;
          allCs = [...allCs, ...data.assetClusters];
          totalCount = data.totalCount;

          hasNextPage = (page - 1) * limit < totalCount;
          page++;
        }

        setAllClusters(allCs);
      } catch (error) {
        console.error(error?.response?.data?.message);
      } finally {
        setLoadingClusters(false);
      }
    };

    if (values.client) {
      getClusters()
    }


  }, [values.client])

  // Fetch categories based on selected client
  useEffect(() => {
    const getCategories = async () => {

      setLoading(true);
      try {
        const { data } = await axiosInstance.get(`/assets/fetch/pre-name?client=${values.client}&cluster=${values.cluster}`);
        setCategories(data?.data?.names);
      } catch (error) {
        toast({
          title: 'Error',
          description: error?.response?.data?.message || 'Failed to fetch categories',
          status: 'error',
        });
      } finally {
        setLoading(false);
      }
    }

    if (values.cluster) {
      getCategories();
    }

  }, [values.cluster]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  // Handle image capture from camera
  const takePicture = () => {
    console.log('yes');
    const width = videoRef.current.videoWidth;
    const height = videoRef.current.videoHeight;
    canvasRef.current.width = width;
    canvasRef.current.height = height;

    const ctx = canvasRef.current.getContext('2d');
    ctx.drawImage(videoRef.current, 0, 0, width, height);

    setHasPhoto(true);
    canvasRef.current.toBlob((blob) => {
      const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
      setValues((prev) => ({ ...prev, image: file }));
    }, 'image/jpeg');
  };

  // Start camera stream
  useEffect(() => {
    const getCameraStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoRef.current.srcObject = stream;
        streamRef.current = stream;
      } catch (err) {
        toast({
          title: 'Error',
          description: 'Failed to access camera',
          status: 'error',
        });
      }
    };

    if (showCamera) {
      getCameraStream();
    } else {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      }
    }
  }, [showCamera]);

  // Submit form
  const create = async () => {
    setCreatingAsset(true);
    const formData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });

    try {
      const { data } = isEdit
        ? await axios.patch(`${url}/assets/edit/${idx}`, formData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('PRV1TK')}` },
        })
        : await axios.post(`${url}/assets/field/register`, formData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('PRV1TK')}` },
        });

      toast({
        description: data?.message,
        status: 'success',
      });
      setTriggerClose(`close${Math.random()}`);
      setRefetch(Math.random());
    } catch (error) {
      toast({
        title: 'Error',
        description: error?.response?.data?.message || 'Failed to submit form',
        status: 'error',
      });
    } finally {
      setCreatingAsset(false);
    }
  };

  return (
    <div className={classes.bigContainer}>
      {loading ? (
        <div className={classes.loader_con}>
          <Spinner />
        </div>
      ) : (
        <div className={classes.formContainer}>
          <div className={classes.inputContainerCon}>
            <label className={classes.label}>Select a client</label>
            <select className={classes.select} name="client" value={values.client} onChange={handleChange}>
              <option value="">Organization*</option>
              {clients?.map((client) => (
                <option key={client._id} value={client.client._id}>
                  {client.client.companyName}
                </option>
              ))}
            </select>
          </div>

          <div className={classes.inputContainerCon}>
            <label className={classes.label}>Select a cluster</label>
            <select className={classes.select} name="cluster" value={values.cluster} onChange={handleChange}>
              <option value="">Cluster</option>
              {allClusters?.map((cluster) => (
                <option key={cluster._id} value={cluster._id}>
                  {cluster.name}
                </option>
              ))}
            </select>
          </div>

          {/* Add other form fields here */}

          <div className={classes.inputContainerCon}>
            <label className={classes.label}>Image</label>
            <p onClick={() => setShowCamera(true)} className={classes.pick_location}>
              Click To Open Camera
            </p>
            {showCamera && (
              <div className={classes.container}>
                <div className={classes.video_container}>
                  <video className={classes.video} ref={videoRef} autoPlay muted />
                  <button className={classes.camera_icon_container} onClick={takePicture}>
                    Take Picture
                  </button>
                </div>
              </div>
            )}
            <canvas className={classes.taken_picture} ref={canvasRef} style={{ display: hasPhoto ? 'block' : 'none' }} />
          </div>

          <button onClick={create} className={classes.submit_response_btn}>
            Submit {creatingAsset && 'ting...'}
          </button>
        </div>
      )}
    </div>
  );
};

export default CreateAssets;